import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllPlanChckList } from "../../Thunks/PlanCheckThunks";
import { PlanCheck } from "../../Types/PlanCheck/PlanCheckType";

interface PlanCheckSliceState {
    loader: boolean; // for refres pages and inital loadings
    planCheckList: PlanCheck[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : PlanCheckSliceState = {
    loader: false,
    planCheckList: [],
    errorDisplay: '',

}

// set state valu for api response
const planCheckSlice = createSlice ({
    name: 'planCheckSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllPlanChckList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllPlanChckList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllPlanChckList.fulfilled, (state, action: PayloadAction<PlanCheck[]>) => {
                    state.planCheckList = [];
                    state.loader = false;
                    state.planCheckList = action.payload;
                  })
    }
})

export const {} = planCheckSlice.actions
export default planCheckSlice.reducer
